/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TaskAdded/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2TaskAddedIcon from 'DesignSystem/Svgs/Tysiav2TaskAddedIcon/index'



/** @type {import('Simple/types.js').View} */
export default function TaskAdded({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Messages/All/Content/Message/MessageTypeIcon/TaskAdded"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Tysiav2TaskAddedIcon
  viewPath={`${viewPath}/Tysiav2TaskAddedIcon`}
 width={14}
 height={14}
 fill={dtColorsNeutral500}
/>
{children}
</React.Fragment>)
}